<!-- <template>
    <div class="md-empty cms-use" :class="[theme,blockName]">
        cms-use md-empty md-team new-style4
        is empty
    </div>
</template> -->
<script>
import { h } from "vue";
export default {
    name: "MdEmpty",
    render(ctx) {
        const mdData = ctx.mdData || {};
        const moduleName = mdData.name;
        const blockName = ctx.$t(`module-name:module-name.${moduleName}`) || moduleName;
        let iconname = 'icon-drawar_02';
        const siteType = false;
        const noDataTip = siteType === 'SubSite' ? ''
            : ctx.$t('common:cmsPreview.doubleClickToConfigure', { blockName: blockName });
        return h('div', {
            class: `${moduleName} ${mdData.theme} cms-use md-empty`,
        }, [
            h('div', {
                class: `empty-content`
            },
            [
                h('span', {
                    class: `iconfont ${iconname} empty-img`
                }),
                h('i', ctx.$t('common:cmsPreview.noData') + '.' + noDataTip)
            ])
        ]);
      
    }
}
</script>